const layout = [{
    path: '/',
    name: 'home',
    redirect: 'nodes',
}, {
    path: '/locations',
    name: 'locations',
    component: resolve => require(['@/views/Locations.vue'], resolve),
}, {
    path: '/nodes',
    name: 'nodes',
    component: resolve => require(['@/views/Nodes.vue'], resolve),
}, {
    path: '/purchase',
    name: 'purchase',
    component: resolve => require(['@/views/Purchase.vue'], resolve),
}, {
    path: '/purchase/checkout',
    name: 'checkout',
    component: resolve => require(['@/views/Checkout.vue'], resolve),
}, {
    path: '/purchase/complete/:sessionId',
    name: 'purchase-complete',
    component: resolve => require(['@/views/PurchaseComplete.vue'], resolve),
}, {
    path: '/nodes/:locationId',
    name: 'nodes-choose-type',
    component: resolve => require(['@/views/Nodes.vue'], resolve),
}, {
    path: '/nodes/:locationId/:nodeType',
    name: 'nodes-choose-node',
    component: resolve => require(['@/views/Nodes.vue'], resolve),
}, {
    path: '/nodes/:locationId/:nodeType/:nodeId',
    name: 'nodes-view',
    component: resolve => require(['@/views/Nodes.vue'], resolve),
}, {
    path: '/orders',
    name: 'orders',
    component: resolve => require(['@/views/MyOrders.vue'], resolve),
}, {
    path: '/orders/:orderId',
    name: 'order',
    component: resolve => require(['@/views/ViewMyOrder.vue'], resolve),
},

// Admin routes
{
    path: '/facility-owners',
    name: 'facility-owners',
    component: resolve => require(['@/views/FacilityOwnerCompanies.vue'], resolve),
    title: 'Facility Owner Companies',
},
{
    path: '/companies',
    name: 'companies',
    component: resolve => require(['@/views/Companies.vue'], resolve),
}, {
    path: '/business-categories',
    name: 'business-categories',
    component: resolve => require(['@/views/BusinessCategories.vue'], resolve),
}, {
    path: '/pricing',
    name: 'pricing',
    component: resolve => require(['@/views/Pricing.vue'], resolve),
}, {
    path: '/checkout-options',
    name: 'checkout-options',
    component: resolve => require(['@/views/CheckoutOptions.vue'], resolve),
}, {
    path: '/customer-orders',
    name: 'customer-orders',
    component: resolve => require(['@/views/CustomerOrders.vue'], resolve),
}, {
    path: '/customer-orders/:orderId',
    name: 'customer-order',
    component: resolve => require(['@/views/ViewCustomerOrder.vue'], resolve),
}, {
    path: '/archived-locations',
    name: 'archived-locations',
    component: resolve => require(['@/views/ArchivedLocations.vue'], resolve),
}
];

export default layout;
